Drupal.behaviors.homeLinkCard = {
  attach: function (context, settings) {
    'use strict';

    var homeLinkCardImages = context.querySelectorAll('.home-link-card img');

    if(homeLinkCardImages.length > 0) {
      objectFitImages(homeLinkCardImages);
    }
 }
};
